module.exports = __webpack_public_path__ + "media/packs/images/partners/okko_logo-28aa838c1d3edab76df8f2244979892b.jpg";